<template>
  <v-container grid-list>
    <div v-if="skeleton_type === SkeletonType.Complex">
      <v-row no-gutters>
        <v-col>
          <v-skeleton-loader
            v-for="n in 2"
            :key="n"
            v-bind="attrs"
            type="card-heading, list-item"
          />
        </v-col>
        <v-col>
          <v-skeleton-loader
            v-for="n in 3"
            :key="n"
            v-bind="attrs"
            type="card-heading, list-item"
          />
        </v-col>
      </v-row>
      <v-skeleton-loader
        v-for="n in 3"
        :key="n"
        v-bind="attrs"
        type="card-heading, list-item"
      />
      <v-skeleton-loader
        v-bind="attrs"
        type="actions"
      />
    </div>
    <div v-if="skeleton_type === SkeletonType.Simple">
      <v-skeleton-loader
        v-for="n in 5"
        :key="n"
        v-bind="attrs"
        type="card-heading, list-item"
      />
      <v-skeleton-loader
        v-bind="attrs"
        type="actions"
      />
    </div>
  </v-container>
</template>

<script>
const SkeletonType = Object.freeze({ Complex: "complex", Simple: "simple" });

export default {
  name: "FormSkeleton",
  props: {
    skeleton_type: { type: String, required: true },
  },
  data: () => ({
    attrs: {
      boilerplate: false,
    },
    SkeletonType,
  }),
};
</script>>